import React from 'react';
import ParticleBackground from './ParticleBackground';

export default function WorkscoreShell({ children }) {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#f5f5f7] relative overflow-hidden">
      <ParticleBackground />
      <div className="relative z-10">{children}</div>
    </div>
  );
}
